module.exports = __webpack_public_path__ + "static/landing_3-b8356670209370b8fbeb4383936f165f.png";